export { Faqs } from './Faqs';
